/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataProjectDTO
 */
export interface AdminDataProjectDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataProjectDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataProjectDTO
     */
    changed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataProjectDTO
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminDataProjectDTO
     */
    deskman?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataProjectDTO
     */
    editorialStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataProjectDTO
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDataProjectDTO
     */
    origin?: string;
}

/**
 * Check if a given object implements the AdminDataProjectDTO interface.
 */
export function instanceOfAdminDataProjectDTO(value: object): value is AdminDataProjectDTO {
    return true;
}

export function AdminDataProjectDTOFromJSON(json: any): AdminDataProjectDTO {
    return AdminDataProjectDTOFromJSONTyped(json, false);
}

export function AdminDataProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
                'created': json['created'] == null ? undefined : (new Date(json['created'])),
                  'deskman': json['deskman'] == null ? undefined : json['deskman'],
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
                  'hidden': json['hidden'] == null ? undefined : json['hidden'],
                  'origin': json['origin'] == null ? undefined : json['origin'],
    };
}

export function AdminDataProjectDTOToJSON(json: any): AdminDataProjectDTO {
    return AdminDataProjectDTOToJSONTyped(json, false);
}

export function AdminDataProjectDTOToJSONTyped(value?: AdminDataProjectDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'changed': value['changed']?.toISOString(),
        'created': value['created']?.toISOString(),
        'deskman': value['deskman'],
        'editorialStatus': value['editorialStatus'],
        'hidden': value['hidden'],
        'origin': value['origin'],
    };
}


